import { render } from "./shops_detail_reviewform.vue?vue&type=template&id=336e7978&scoped=true"
import script from "./shops_detail_reviewform.vue?vue&type=script&lang=js"
export * from "./shops_detail_reviewform.vue?vue&type=script&lang=js"

import "./shops_detail_reviewform.vue?vue&type=style&index=0&id=336e7978&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336e7978"]])

export default __exports__